import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import {
  SetExpectedVolumeInput,
  UpdateGoalExpectedVolumeMutation,
  UpdateGoalExpectedVolumeMutationVariables,
} from "@/gql/graphql";
import { rebateProgressQuery } from "./UseRebateProgress";

const mutation = gql`
  mutation UpdateGoalExpectedVolume($input: SetExpectedVolumeInput!) {
    productPrice {
      rebate {
        setExpectedVolume(input: $input)
      }
    }
  }
`;

export const useUpdateGoalExpectedVolume = () => {
  const [mutate, { loading, error }] = useMutation<
    UpdateGoalExpectedVolumeMutation,
    UpdateGoalExpectedVolumeMutationVariables
  >(mutation, {
    refetchQueries: [rebateProgressQuery, "RebateProgressFetcher"],
  });

  const updateGoalExpectedVolume = useCallback(
    (input: SetExpectedVolumeInput) => {
      return mutate({ variables: { input } });
    },
    [mutate]
  );

  return {
    updateGoalExpectedVolume,
    loading,
    error,
  };
};
